import React, { useEffect, useState } from "react";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./VisionIgniteWebinar.css";

const getNextSaturday = () => {
  const now = new Date();
  const next = new Date(now);
  const daysUntilSaturday = (6 - next.getDay() + 7) % 7;
  next.setDate(next.getDate() + daysUntilSaturday);
  next.setHours(17, 0, 0, 0);

  if (next <= now) {
    next.setDate(next.getDate() + 7);
  }

  return next;
};

// Generate a mock transaction ID like: 6a72ee7ecb4d2540925...
const generateTransactionId = () => {
  const chars = "abcdef0123456789";
  let id = "";
  for (let i = 0; i < 20; i++) {
    id += chars[Math.floor(Math.random() * chars.length)];
  }
  return id;
};

// Format a Date object into the UTC string Google Calendar needs: YYYYMMDDTHHMMSSZ
const formatGCalDate = (date) => {
  return date.toISOString().replace(/-|:|\.\d+/g, "");
};

const SITUATION_OPTIONS = [
  "I wear glasses for distance",
  "I wear glasses mainly for reading / near work",
  "I wear glasses throughout the day",
  "I use contact lenses",
  "I'm registering for my child",
  "I don't wear glasses, but want healthier vision",
];

const REASON_OPTIONS = [
  "I want to reduce my dependence on glasses",
  "My prescription keeps increasing",
  "Screen time is affecting my eyes",
  "I want to help my child",
  "I want healthier vision habits",
  "I'm curious whether vision training actually works",
];

const DURATION_OPTIONS = [
  "Less than 1 year",
  "1–3 years",
  "3–5 years",
  "5–10 years",
  "More than 10 years",
];

const VisionIgniteWebinar = () => {
  // Hide website footer
 useEffect(() => {
     const navbar = document.querySelector("header, .navbar");
     const footer = document.querySelector("footer");
 
     if (navbar) navbar.style.display = "none";
     if (footer) footer.style.display = "none";
 
     return () => {
       if (navbar) navbar.style.display = "";
       if (footer) footer.style.display = "";
     };
   }, []);

  // Remove ElevenLabs widget
  useEffect(() => {
    const hideWidget = () => {
      document.querySelectorAll("elevenlabs-convai").forEach(el => el.remove());
      document
        .querySelectorAll("iframe,[class*='convai'],[id*='convai']")
        .forEach(el => el.remove());
    };

    hideWidget();
    const interval = setInterval(hideWidget, 500);
    return () => clearInterval(interval);
  }, []);

  // Scroll top
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Countdown target
  const [targetDate, setTargetDate] = useState(getNextSaturday());

  // Countdown
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const [registered, setRegistered] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState("");
  const [registeredName, setRegisteredName] = useState("");
  const [transactionId, setTransactionId] = useState("");

  // Registered count
  const [weekCount, setWeekCount] = useState(0);

  // Form
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: ""
  });

  const TOTAL_SEATS = 10;
  const [remainingSeats, setRemainingSeats] = useState(TOTAL_SEATS);
  const [loading, setLoading] = useState(false);

  // WhatsApp community invite link
  const [whatsappLink, setWhatsappLink] = useState("");

  // ---- Reserve-seat modal (3-step qualifying flow) ----
  const [showModal, setShowModal] = useState(false);
  const [step, setStep] = useState(1);
  const [situation, setSituation] = useState("");
  const [reason, setReason] = useState("");
  const [glassesDuration, setGlassesDuration] = useState("");
  const [consent, setConsent] = useState(false);

  const openModal = () => {
    setStep(1);
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);
  const goNext = () => setStep((s) => Math.min(s + 1, 3));
  const goBack = () => setStep((s) => Math.max(s - 1, 1));

  // Countdown
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const diff = targetDate - now;

      if (diff <= 0) {
        setTargetDate(getNextSaturday());
        return;
      }

      setCountdown({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor(diff / (1000 * 60 * 60)) % 24,
        minutes: Math.floor(diff / (1000 * 60)) % 60,
        seconds: Math.floor(diff / 1000) % 60
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  // Weekly registrations
  useEffect(() => {
    const loadCount = async () => {
      try {
        const res = await axios.get("/api/vision-ignite-week-count");
        setWeekCount(res.data.count);

        const seats = TOTAL_SEATS - res.data.count;
        setRemainingSeats(seats <= 2 ? 2 : seats);
      } catch (err) {
        console.log(err);
      }
    };

    loadCount();
    const interval = setInterval(loadCount, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const loadWhatsappLink = async () => {
      try {
        const res = await axios.get("/api/webinar-settings");
        setWhatsappLink(res.data.visionIgniteWhatsappLink || "");
      } catch (err) {
        console.log(err);
      }
    };

    loadWhatsappLink();
  }, []);

  // Auto-redirect to WhatsApp community after success
  useEffect(() => {
    console.log("registered:", registered);
    console.log("whatsappLink:", whatsappLink);

    if (registered && whatsappLink) {
      const waTimer = setTimeout(() => {
        console.log("Redirecting to:", whatsappLink);
        window.location.replace(whatsappLink);
      }, 1000);

      return () => clearTimeout(waTimer);
    }
  }, [registered, whatsappLink]);

  // Lock page scroll while overlay/modal is open
  useEffect(() => {
    document.body.style.overflow = (loading || registered || showModal) ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [loading, registered, showModal]);

  // Input
  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

 

  // Add to calendar (Google Calendar)
  const handleAddToCalendar = () => {
    const startDate = new Date(targetDate);
    const endDate = new Date(targetDate.getTime() + 60 * 60 * 1000); // +1 hour

    const gcalUrl =
      "https://www.google.com/calendar/render?action=TEMPLATE" +
      "&text=" + encodeURIComponent("The Clear Vision Blueprint - Free Live Webinar") +
      "&dates=" + formatGCalDate(startDate) + "/" + formatGCalDate(endDate) +
      "&details=" + encodeURIComponent(
        "Join Vevek Seetharaman for a free live Clear Vision Blueprint session — measure your visual baseline, learn how vision habits work, and train deliberately. Zoom link will be emailed 1 hour before the webinar."
      ) +
      "&location=" + encodeURIComponent("Online - Zoom") +
      "&sf=true&output=xml";

    window.open(gcalUrl, "_blank");
  };

  // Register
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setShowModal(false);
      setLoading(true);

      const registrationResponse =
  await axios.post("/api/vision-ignite-webinar-register", {
    ...formData,
    visionSituation: situation,
    biggestReason: reason,
    glassesDuration,
    metaFbp: document.cookie
      .split("; ")
      .find(row => row.startsWith("_fbp="))
      ?.split("=")[1] || "",
    metaFbc: document.cookie
      .split("; ")
      .find(row => row.startsWith("_fbc="))
      ?.split("=")[1] || "",
    metaUserAgent: navigator.userAgent,
  });

const metaLeadEventId =
  registrationResponse.data.metaLeadEventId;

// 🔥 Meta Pixel - successful webinar registration
if (window.fbq) {

  // VISION IGNITE PIXEL → Lead
  window.fbq(
    "trackSingle",
    "2184603352474386",
    "Lead",
    {
      content_category: situation,
      content_name: reason,
      value: 0,
      currency: "INR",
    },
    {
      eventID: metaLeadEventId,
    }
  );

  const clean = (str) =>
    str.replace(/[^a-zA-Z0-9]/g, "_").substring(0, 40);

  // VISION SITUATION
  window.fbq(
    "trackSingle",
    "2184603352474386",
    "VisionSituation_" + clean(situation)
  );

  // BIGGEST REASON
  window.fbq(
    "trackSingle",
    "2184603352474386",
    "BiggestReason_" + clean(reason)
  );

  // GLASSES DURATION
  if (glassesDuration) {
    window.fbq(
      "trackSingle",
      "2184603352474386",
      "GlassesDuration_" + clean(glassesDuration)
    );
  }
}

if (window.gtag) {
  window.gtag("event", "vision_ignite_registration_success", {
    page: "/vision-ignite-webinar",
    vision_situation: situation,
    biggest_reason: reason,
    glasses_duration: glassesDuration || "not_specified",
  });
}

      setRegisteredEmail(formData.email);
      setRegisteredName(formData.name);
      setTransactionId(generateTransactionId());

      setTimeout(() => {
        setLoading(false);
        setRemainingSeats(prev => (prev <= 2 ? 2 : prev - 1));
        setRegistered(true);
      }, 3000);

    } catch (err) {
      setLoading(false);
      alert(err.response?.data?.message || "Registration Failed");
    }
  };
  const [openFaqIndex, setOpenFaqIndex] = useState(0);

  const faqItems = [
  {
    q: "Will this remove my need for glasses completely?",
    a: "Many people do eliminate their need for glasses completely - especially when they're consistent with the training. Some reduce dependence significantly. Some find they no longer need them for sports but still wear them for reading. The framework works. How far you go depends on how you apply it and how long you've worn glasses. The Bates Method has decades of research behind it; the question isn't whether it works, it's whether you'll do the work."
  },
  {
    q: "Is this really free? Is there a catch?",
    a: "Yes, this webinar is completely free "
  },
  {
    q: "Will there be a recording?",
    a: "No, there will not be a recording of this session, this feature maybe considered in the future"
  },
  
  {
    q: "Is this only for people who already wear glasses?",
    a: "No. Anyone whose eyes spend long hours on screens can benefit from healthier visual habits — whether or not you currently wear glasses."
  },
  {
    q: "Is this a sales pitch?",
    a: "I mention Vision Ignite at the end for people who want to go deeper. But this webinar is complete on its own. You'll leave with the full framework and actionable techniques regardless of whether you buy."
  }
];



  return (
    <div className="cvb-page">

      {/* FULLSCREEN OVERLAYS */}
      {loading && (
        <div className="cvb-fullscreen-overlay">
          <div className="cvb-loading-screen">
            <div className="cvb-loader-circle">
              <div className="cvb-loader-ring"></div>
            </div>
            <h2 className="cvb-loading-title">Reserving Your Seat...</h2>
            <p className="cvb-loading-subtitle">
              Please wait while we secure your seat for the session.
            </p>
          </div>
        </div>
      )}

      {registered && !loading && (
        <div className="cvb-fullscreen-overlay">
          <div className="cvb-receipt-success">
            <div className="cvb-receipt-header">
              <div className="cvb-receipt-check">✓</div>
              <h2>Registration Successful</h2>
              <h3>₹999 <span>FREE</span></h3>
            </div>

            <div className="cvb-receipt-zigzag">
              {Array.from({ length: 22 }).map((_, i) => (
                <span key={i}></span>
              ))}
            </div>

            <div className="cvb-receipt-body">
              <div className="cvb-receipt-row">
                <span>Transaction ID</span>
                <strong>{transactionId}</strong>
              </div>
              <div className="cvb-receipt-row">
                <span>Session</span>
                <strong>The Clear Vision Blueprint</strong>
              </div>
              <div className="cvb-receipt-row">
                <span>Registration Method</span>
                <strong>Free Registration</strong>
              </div>
              <div className="cvb-receipt-row">
                <span>Registration Time</span>
                <strong>
                  {new Date().toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })}
                  <br />
                  {new Date().toLocaleTimeString("en-US", {
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </strong>
              </div>

              <div className="cvb-receipt-divider"></div>

              <h4 className="cvb-billing-title">Billing Details</h4>
              <div className="cvb-billing-item"><strong>{formData.name}</strong></div>
              <div className="cvb-billing-item">{registeredEmail}</div>
              <div className="cvb-billing-item">{formData.phoneNumber}</div>
            </div>

            <p className="cvb-receipt-note">
              Redirecting you to our WhatsApp community...
            </p>
          </div>
        </div>
      )}

      {/* RESERVE-SEAT MODAL — 3 step qualifying flow */}
      {showModal && (
        <div className="cvb-modal-overlay" onClick={closeModal}>
          <div className="cvb-modal" onClick={(e) => e.stopPropagation()}>

            <div className="cvb-modal-topbar">
              {step > 1 ? (
                <button className="cvb-modal-back" onClick={goBack} aria-label="Back">←</button>
              ) : <span />}

              <div className="cvb-modal-progress">
                {[1, 2, 3].map((s) => (
                  <div
                    key={s}
                    className={"cvb-modal-progress-seg" + (s <= step ? " filled" : "")}
                  ></div>
                ))}
              </div>

              <div className="cvb-modal-topbar-right">
                <span className="cvb-modal-count">{step}/3</span>
                <button className="cvb-modal-close" onClick={closeModal} aria-label="Close">✕</button>
              </div>
            </div>

            {/* STEP 1 */}
            {step === 1 && (
              <div className="cvb-modal-body">
                <h2>What best describes your current situation?</h2>
                <p className="cvb-modal-sub">
                  This helps us tailor the live session to the people in the room.
                </p>

                <div className="cvb-modal-options">
                  {SITUATION_OPTIONS.map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={"cvb-modal-option" + (situation === opt ? " selected" : "")}
                      onClick={() => setSituation(opt)}
                    >
                      <span>{opt}</span>
                      <span className="cvb-modal-radio"></span>
                    </button>
                  ))}
                </div>

                <button
                  className="cvb-btn cvb-btn-primary cvb-modal-continue"
                  disabled={!situation}
                  onClick={goNext}
                >
                  Continue
                </button>
              </div>
            )}

            {/* STEP 2 */}
            {step === 2 && (
              <div className="cvb-modal-body">
                <h2>What's the biggest reason you're joining?</h2>
                <p className="cvb-modal-sub">One answer is enough.</p>

                <div className="cvb-modal-options">
                  {REASON_OPTIONS.map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={"cvb-modal-option" + (reason === opt ? " selected" : "")}
                      onClick={() => setReason(opt)}
                    >
                      <span>{opt}</span>
                      <span className="cvb-modal-radio"></span>
                    </button>
                  ))}
                </div>

                <p className="cvb-modal-label">
                  How long have you been using glasses? <em>(optional)</em>
                </p>
                <div className="cvb-modal-chips">
                  {DURATION_OPTIONS.map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={"cvb-modal-chip" + (glassesDuration === opt ? " selected" : "")}
                      onClick={() =>
                        setGlassesDuration(glassesDuration === opt ? "" : opt)
                      }
                    >
                      {opt}
                    </button>
                  ))}
                </div>

                <button
                  className="cvb-btn cvb-btn-primary cvb-modal-continue"
                  disabled={!reason}
                  onClick={goNext}
                >
                  Continue
                </button>
              </div>
            )}

            {/* STEP 3 */}
            {step === 3 && (
              <form className="cvb-modal-body" onSubmit={handleSubmit}>
                <h2>Where should we send your seat?</h2>
                <p className="cvb-modal-sub">
                  {targetDate.toLocaleDateString("en-GB", {
                    weekday: "long",
                    day: "2-digit",
                    month: "long",
                  })}{" "}
                  · 5:00 PM IST · Live online · Free
                </p>

                <label className="cvb-modal-field-label">Full name</label>
                <input
                  type="text"
                  name="name"
                  className="cvb-modal-input"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />

                <label className="cvb-modal-field-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="cvb-modal-input"
                  placeholder="you@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />

                <label className="cvb-modal-field-label">
                  WhatsApp Number
                </label>

                <PhoneInput
                  country={"in"}
                  value={formData.phoneNumber}
                  onChange={(phone) =>
                    setFormData({
                      ...formData,
                      phoneNumber: "+" + phone
                    })
                  }
                  enableSearch={true}
                  countryCodeEditable={false}
                  inputProps={{
                    name: "phoneNumber",
                    required: true,
                    autoComplete: "tel"
                  }}
                  placeholder="Enter phone number"
                />

                <label className="cvb-modal-consent">
                  <input
                    type="checkbox"
                    checked={consent}
                    onChange={(e) => setConsent(e.target.checked)}
                    required
                  />
                  <span>
                    I agree to receive my joining link, reminders and related
                    updates about The Clear Vision Blueprint on WhatsApp,
                    email and SMS. I can opt out anytime.
                  </span>
                </label>

                <button
                  type="submit"
                  className="cvb-btn cvb-btn-primary cvb-modal-continue"
                  disabled={loading || !consent}
                >
                  Complete my free registration
                </button>

                <p className="cvb-modal-privacy">
                  🛡 We never ask for medical records or clinical history, and
                  we don't share your details with third parties for advertising.
                </p>
              </form>
            )}
          </div>
        </div>
      )}

      {/* HEADER */}
      <header className="cvb-header">
        <div className="cvb-wrap cvb-header-inner">
          <div className="cvb-brand">
            <span className="cvb-brand-black">The Clear</span>{" "}
            <span className="cvb-brand-accent">Vision Blueprint</span>
          </div>
          <div className="cvb-header-nav">MEASURE · TRAIN · TRANSFORM</div>
        </div>
      </header>

      {/* HERO */}
      <section className="cvb-hero">
        <div className="cvb-wrap cvb-hero-grid">
          <div>
            <span className="cvb-eyebrow-pill">
              Live online · {targetDate.toLocaleDateString("en-GB", { weekday: "long", day: "2-digit", month: "long" })} · 5:00 PM IST
            </span>

            <h1>
              Before you accept glasses for life{" "}
              <span className="cvb-accent-text">give us 60 minutes.</span>
            </h1>

            <p className="cvb-sub">
              A live, practical Clear Vision Blueprint session where we measure
              where your vision stands today, explain why visual habits matter,
              and teach techniques designed to help you build healthier visual
              behaviour — and reduce unnecessary dependence on corrective lenses.
            </p>

            <div className="cvb-cta-row">
              <button className="cvb-btn cvb-btn-primary" onClick={openModal}>
                Reserve my free seat →
              </button>
              <button className="cvb-btn cvb-btn-ghost" onClick={handleAddToCalendar}>
                Add to calendar
              </button>
            </div>

            <div className="cvb-price-line">
              <span className="cvb-price-strike">₹999</span>
              <span className="cvb-price-free">FREE live webinar</span>
            </div>

            <div className="cvb-countdown">
              <div><h2>{String(countdown.days).padStart(2, "0")}</h2><span>Days</span></div>
              <div><h2>{String(countdown.hours).padStart(2, "0")}</h2><span>Hours</span></div>
              <div><h2>{String(countdown.minutes).padStart(2, "0")}</h2><span>Minutes</span></div>
              <div><h2>{String(countdown.seconds).padStart(2, "0")}</h2><span>Seconds</span></div>
            </div>

            <p className="cvb-fine">
              No prior knowledge required · Join from your phone or laptop
            </p>
          </div>

          <div className="cvb-hero-visual">
            <img
              src="/Hero/clear-vision-hero.jpg"
              alt="Person taking a moment away from their laptop"
              className="cvb-hero-photo"
            />
            <div className="cvb-hero-caption">
              <strong>Your baseline matters.</strong> Because improvement
              should be measured — not imagined.
            </div>
          </div>
        </div>
      </section>

      {/* THE QUESTION NOBODY ASKED */}
      <section className="cvb-band">
        <div className="cvb-wrap">
          <div className="cvb-sec-head-left">
            <span className="cvb-eyebrow">The question nobody asked you</span>
            <h2>You were given glasses.<br />But were you ever taught how vision works?</h2>
          </div>

          <div className="cvb-pipeline">
            {["Blur", "Eye test", "Prescription", "Glasses", "New prescription"].map((s, i) => (
              <React.Fragment key={s}>
                <div className="cvb-pipeline-step">{s}</div>
                {i < 4 && <div className="cvb-pipeline-arrow">→</div>}
              </React.Fragment>
            ))}
          </div>

          <h3 className="cvb-gap-heading">But what happens between those eye tests?</h3>
          <p className="cvb-gap-copy">
            Roughly 5,000 waking hours a year of how you actually use your
            eyes. The Clear Vision Blueprint looks at that gap — your visual
            habits, your visual performance, and what can be trained and
            measured — instead of asking you to accept a changing number
            without understanding it.
          </p>

          <div style={{ textAlign: "center" }}>
            <button className="cvb-btn cvb-btn-primary" onClick={openModal}>
              Reserve my free seat →
            </button>
          </div>
        </div>
      </section>

      {/* TEST YOURSELF */}
      <section className="cvb-band cvb-alt">
        <div className="cvb-wrap cvb-test-grid">
          <div>
            <span className="cvb-eyebrow">Experience before belief</span>
            <h2>Don't believe us. <span className="cvb-accent-text">Test yourself.</span></h2>
            <p>
              We don't want you joining because of a promise. We want you to
              observe your own vision. During The Clear Vision Blueprint we
              introduce simple ways to understand and observe aspects of your
              current visual performance — live, with you participating.
            </p>
            <div className="cvb-baseline-quote">
              <strong>Your baseline matters.</strong>
              <p>Because improvement should be measured — not imagined.</p>
            </div>
            <a
            className="cvb-btn cvb-btn-primary"
            href="/visual-acuity-chart.pdf"
            download="visual-acuity-chart.pdf"
          >
            I want to measure my vision →
          </a>
          </div>
          <div>
            <img
              src="/Hero/clear-vision-selftest.jpg"
              alt="Person doing a simple self-assessment"
              className="cvb-test-photo"
            />
            
          </div>
        </div>
      </section>

      {/* THREE DISCOVERIES */}
      <section className="cvb-band">
        <div className="cvb-wrap">
          <div className="cvb-sec-head cvb-sec-head-left">
            <span className="cvb-eyebrow">What you'll discover</span>
            <h2>Three discoveries in one session.</h2>
          </div>

          <div className="cvb-discoveries">
            <div className="cvb-discovery">
              <div className="cvb-num">01</div>
              <h3>Why Your Eyes Behave the Way They Do</h3>
              <p>
                Understand the relationship between visual habits, near work,
                relaxation and focus — and how the way you use your eyes
                through the day shapes what they do next.
              </p>
            </div>
            <div className="cvb-discovery">
              <div className="cvb-num">02</div>
              <h3>How to Train Better Visual Habits</h3>
              <p>
                Experience practical vision-training principles you can fit
                into ordinary life: visual relaxation, changing viewing
                distance, outdoor visual behaviour and more.
              </p>
            </div>
            <div className="cvb-discovery">
              <div className="cvb-num">03</div>
              <h3>How to Measure Whether Anything Is Actually Changing</h3>
              <p>
                See how The Clear Vision Blueprint thinks about baseline →
                training → reassessment. Never guess when you can measure.
              </p>
            </div>
          </div>

          <p className="cvb-tagline">Never guess when you can measure.</p>
          <div style={{ textAlign: "center" }}>
            <button className="cvb-btn cvb-btn-primary" onClick={openModal}>
              Reserve my free seat →
            </button>
          </div>
        </div>
      </section>

      {/* IS THIS FOR YOU */}
      <section className="cvb-band cvb-alt">
        <div className="cvb-wrap">
          <span className="cvb-eyebrow">Is this for you?</span>
          <h2 className="cvb-for-you-title">The Clear Vision Blueprint may be for you if…</h2>

          <div className="cvb-checklist-grid">
            {[
              "Your spectacle prescription keeps changing",
              "You feel helpless without your glasses",
              "Your work demands hours of screen time",
              "You want to understand your eyes rather than simply replace lenses",
              "You're a parent watching your child's power increase",
              "You want to explore what better visual habits can realistically improve",
              "You're skeptical — but curious enough to measure the outcome",
            ].map((item) => (
              <div className="cvb-checklist-card" key={item}>
                <span className="cvb-check-icon">✓</span>
                <span>{item}</span>
              </div>
            ))}
          </div>

          <div className="cvb-not-about-card">
            <h3><span className="cvb-info-icon">ⓘ</span> This is not about throwing away your glasses tomorrow.</h3>
            <p>
              The Clear Vision Blueprint is about understanding your visual
              system, learning better habits, and objectively observing what
              changes. Corrective lenses should still be used whenever clear
              vision is necessary for safety or daily function.
            </p>
          </div>
        </div>
      </section>

      {/* METHOD: MEASURE TRAIN TRANSFORM */}
      <section className="cvb-band" id="how">
        <div className="cvb-wrap">
          <div className="cvb-sec-head">
            <span className="cvb-eyebrow">The Clear Vision Blueprint method</span>
            <h2>Measure. Train. Transform.</h2>
          </div>
          <div className="cvb-method">
            <div className="cvb-method-step">
              <div className="cvb-method-badge">01</div>
              <h3>Measure</h3>
              <p>Know where you are.</p>
            </div>
            <div className="cvb-method-arrow">↓</div>
            <div className="cvb-method-step">
              <div className="cvb-method-badge">02</div>
              <h3>Train</h3>
              <p>Train visual behaviours deliberately.</p>
            </div>
            <div className="cvb-method-arrow">↓</div>
            <div className="cvb-method-step">
              <div className="cvb-method-badge">03</div>
              <h3>Transform</h3>
              <p>Reassess and discover what changed.</p>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS — using existing testimonial data/logic */}
      <section className="cvb-band cvb-alt">
        <div className="cvb-wrap">
          <div className="cvb-sec-head cvb-sec-head-left">
            <span className="cvb-eyebrow">Measured stories</span>
            <h2>Starting point → training period → measured change.</h2>
          </div>
          <div className="cvb-testi-grid">
            {[
              {
                name: "Aaditya B",
                role: "22 · Cricketer",
                photo: "/testimonials/aaditya.Png",
                quote:
                  "Wearing glasses while playing was a menace, was considering LASIK/contacts. Forge Your Peak was able to help reverse my eyesight naturally — now I play without glasses, which I thought was impossible once."
              },
              {
                name: "Aravindh",
                role: "26 · Engineer",
                photo: "/testimonials/aravindh.jpeg",
                quote:
                  "Forge Your Peak helped me improve my vision naturally. It's been 4 years, and I'm still glasses free."
              },
              {
                name: "Girinath Nagarajan",
                role: "21 · Cricketer",
                photo: "/testimonials/girinath.jpeg",
                quote:
                  "I reversed my eyesight naturally and permanently said goodbye to my glasses. The team motivated me to go all the way and gave me the confidence to start playing without glasses."
              },
              {
                name: "Gowrisankar",
                role: "27 · IT Engineer",
                photo: "/testimonials/gowrisankar.jpg",
                quote:
                  "I was wearing thick glasses of 4.5D all my life. Now I don't wear them for anything except as a fashion statement."
              }
            ].map((t, index) => (
              <div className="cvb-testi-card" key={index}>
                <span className="cvb-quote-icon">❝</span>
                <p className="cvb-testi-quote">"{t.quote}"</p>
                <div className="cvb-testi-divider"></div>
                <div className="cvb-testi-person">
                  <img src={t.photo} alt={t.name} className="cvb-testi-photo" />
                  <div>
                    <div className="cvb-testi-name">{t.name}</div>
                    <div className="cvb-testi-role">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOST */}
      <section className="cvb-band">
        <div className="cvb-wrap cvb-host-grid">
          <img src="/Hero/Vevek-hero.jpeg" alt="Vevek Seetharaman" className="cvb-host-photo" />
          <div>
            <span className="cvb-eyebrow">Who's teaching</span>
            <h2>Vevek Seetharaman</h2>
            <p className="cvb-host-cred">Founder, Forge Your Peak</p>
            <p className="cvb-bio">
              Years spent working across vision, sports vision, neuro-athletic
              performance and the Bates Method led to one obsession:
            </p>
            <blockquote className="cvb-host-quote">
              "What parts of human visual performance can actually be
              measured and trained?"
            </blockquote>
            <p className="cvb-bio">
              That exploration became the Measure → Train → Transform
              methodology behind The Clear Vision Blueprint.
            </p>
            
          </div>
        </div>
      </section>

      {/* FIVE YEARS FROM NOW */}
      <section className="cvb-band cvb-alt">
        <div className="cvb-wrap">
          <div className="cvb-sec-head cvb-sec-head-left">
            <span className="cvb-eyebrow">Five years from now</span>
            <h2>
              You can't control everything about your eyes.<br />
              <span className="cvb-muted-heading">But you can stop being passive about them.</span>
            </h2>
          </div>
          <div className="cvb-passive-active">
            <div className="cvb-pa-col cvb-passive">
              <h3>Passive</h3>
              <ul>
                <li>Eye test</li>
                <li>Stronger prescription</li>
                <li>New glasses</li>
                <li>Repeat</li>
              </ul>
            </div>
            <div className="cvb-pa-col cvb-active">
              <h3>Active</h3>
              <ul>
                <li>Measure</li>
                <li>Understand</li>
                <li>Improve habits</li>
                <li>Train</li>
                <li>Reassess</li>
              </ul>
            </div>
          </div>
          <div style={{ textAlign: "center", marginTop: 32 }}>
            <button className="cvb-btn cvb-btn-primary" onClick={openModal}>
              Reserve my free seat →
            </button>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section className="cvb-band">
        <div className="cvb-wrap">
          <div className="cvb-pricing-card">
            <h3>The Clear Vision Blueprint — Live</h3>
            <div className="cvb-pricing-amount">
              <span className="cvb-price-strike">₹999</span>
              <span className="cvb-price-free">FREE</span>
            </div>
            <ul className="cvb-pricing-list">
              <li>Live Clear Vision Blueprint webinar</li>
              <li>Practical vision-training session</li>
              <li>Vision self-assessment guidance</li>
              <li>Live Q&A</li>
              <li>Attend online from anywhere</li>
            </ul>
            <button className="cvb-btn cvb-btn-primary cvb-pricing-btn" onClick={openModal}>
              Reserve my free seat →
            </button>
            <p className="cvb-fine">
              Next session:{" "}
              <strong>
                {targetDate.toLocaleDateString("en-GB", {
                  weekday: "long",
                  day: "2-digit",
                  month: "long",
                })}
              </strong>{" "}
              at 5:00 PM IST
              <br />
              Live online · Attend from anywhere
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="cvb-band cvb-alt">
        <div className="cvb-wrap">
          <div className="cvb-sec-head cvb-sec-head-left">
            <span className="cvb-eyebrow">Questions</span>
            <h2>Everything you might be wondering.</h2>
          </div>
          <div className="cvb-faq-list">
            {faqItems.map((item, index) => (
              <div
                className={"cvb-faq-item" + (openFaqIndex === index ? " open" : "")}
                key={index}
              >
                <button
                  className="cvb-faq-q"
                  onClick={() => setOpenFaqIndex(openFaqIndex === index ? -1 : index)}
                >
                  {item.q}
                  <span className="cvb-chevron">{openFaqIndex === index ? "︿" : "﹀"}</span>
                </button>
                {openFaqIndex === index && (
                  <div className="cvb-faq-a"><p>{item.a}</p></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="cvb-final-section">
        <div className="cvb-wrap">
          <div className="cvb-final">
            <h2>Your eyes are worth understanding.</h2>
            <p className="cvb-sub2">
              Before you simply accept another prescription, spend one
              session understanding what your eyes are doing — and what you
              can do differently.
            </p>

            <div className="cvb-price-line cvb-price-line-center">
              <span className="cvb-price-strike">₹999</span>
              <span className="cvb-price-free">FREE</span>
            </div>

            <button className="cvb-btn cvb-btn-primary cvb-final-btn" onClick={openModal}>
              Reserve my seat for The Clear Vision Blueprint →
            </button>

            <p className="cvb-fine">
              Next session:{" "}
              {targetDate.toLocaleDateString("en-GB", {
                weekday: "long",
                day: "2-digit",
                month: "long",
              })}{" "}
              · 5:00 PM IST
            </p>

            <p className="cvb-tagline-small">Measure. Train. Transform.</p>
          </div>
        </div>
      </section>

     
    </div>
  );
};

export default VisionIgniteWebinar;